import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

interface GiftingLayoutProps {
  children: ReactNode;
}

export function GiftingLayout({ children }: GiftingLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-gifting-gradient">
      <Header />
      <main className="flex-1 flex items-center justify-center py-8 bg-bg-cream/80 px-5 md:px-0">
        {children}
      </main>
      <Footer />
    </div>
  );
}